import { Link, useLocation } from "react-router-dom";
import { cn } from "../../../app/utils/cn";

interface NavBarProps {
  menus: {
    label: string;
    path: string;
    icon: React.ReactNode;
    isActive?: boolean;
    count?: number;
  }[];
}

export const NavBar = ({ menus }: NavBarProps) => {
  const location = useLocation();

  const locationPath = location.pathname;

  return (
    <ul className="mt-5 flex w-full flex-col items-start gap-4 font-semibold">
      {menus.map(({ icon, label, path, isActive, count }) => (
        <Link className="w-full" to={path} key={path}>
          <li
            className={cn(
              "flex h-11 w-52 items-center gap-2 px-6 py-2",
              isActive && "border-2 border-dashed border-primary rounded-full text-primary",
              locationPath.startsWith(path)
                ? "rounded-full bg-primary text-white"
                : "text-black04",
            )}
          >
            {icon}
            <p>{label}</p>

            {!!count && (
              <span
                className={cn(
                  "ml-auto flex h-8 w-8 items-center justify-center rounded-full bg-primary text-white",
                )}
              >
                {count > 99 ? "+99" : count}
              </span>
            )}
          </li>
        </Link>
      ))}
    </ul>
  );
};
